/**
 * Current ReefApp version, surfaced to the UI (e.g., the /settings → System
 * card). Sourced from the root `package.json` `version` field.
 *
 * NOTE: This is a manual mirror of the version string. The web bundle does
 * not import the root `package.json` directly because:
 *   - The web `tsconfig.json` only includes `src/`, so reaching outside the
 *     workspace would break `tsc -p` resolution.
 *   - Vite cannot statically resolve a path outside the project root with
 *     `resolveJsonModule` in this monorepo layout.
 * Bump this in lockstep with the root `package.json` when the version
 * changes. A future milestone (M2.x) may replace this with a Vite `define`
 * injection at build time.
 */
export const APP_VERSION = '0.1.0';